export class EpbtFaEpaReturnParametersModel {
    constructor(response: any) {
        this.success = response['success'];
        this.token = response['token'];
        this.transid = response['transid'];
        this.lastfour = response['lastfour'];
        this.masked = response['masked'];
        this.cardtype = response['cardtype'];
        this.expdate = response['expdate'];
        this.cvv = response['cvv'];
        this.billingAddress = response['billingAddress'];
        this.postalCode = response['postalCode'];
    }

    public success: boolean;
    public token: string;
    public transid: string;
    public lastfour: string;
    public masked: string;
    public cardtype: string;
    public expdate: string;
    public cvv: string;
    public billingAddress: string;
    public postalCode: string;
}
